import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DomPurify from 'dompurify';
import { ImgWebp } from '../../components/commons/ImgWeb';
import AccessDeniedImageLight from '../../assets/images/AccessDeniedLight.png';
import AccessDeniedImageDark from '../../assets/images/AccessDeniedDark.png';
import '../404/Page404.scss';
import { CustomMUIButton } from '../../components/commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../models/Common';
import { useAppSelector } from '../../hooks/redux';

export const AccessDenied = () => {
  const { t } = useTranslation();
  const { theme } = useAppSelector((state) => state.appReducer);
  const history = useHistory();
  const sanitizer = DomPurify.sanitize;

  const handleButton = () => {
    history.push(GlobalRouteNames.HomePage);
  };

  return (
    <div className="page-404 page">
      <div className="page-404__container container">
        <ImgWebp
          fallback={theme === 'light' ? AccessDeniedImageLight : AccessDeniedImageDark}
          alt="access denied"
          className="page-404__image"
        />
        <div className="page-404__content">
          <h1>{t('accessDenied.pageNotAvailable')}</h1>
          <div className="page-404__content__text-btn-container">
            <p dangerouslySetInnerHTML={{ __html: sanitizer(t('accessDenied.deniedDescription')) }} />
            <CustomMUIButton
              label={t('buttons.goBackToMainPage')}
              handleClick={handleButton}
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
            />
          </div>
        </div>
      </div>
    </div>
  );
};
